import React from "react";
import { BoxIcon } from "lucide-react";
export function TrustLine({
  items
}: {
  items: {
    icon: BoxIcon;
    label: string;
  }[];
}) {
  return <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-semibold text-muted" data-id="element-277" data-mp="3ox42mtbqo7zl">
      {items.map(({
      icon: Icon,
      label
    }) => <li key={label} className="flex items-center gap-1.5" data-id="element-278" data-mp="3fysc0ravha75">
          <Icon className="h-4 w-4 text-brand" aria-hidden="true" data-id="element-279" data-mp="gidllassq7a2" />
          {label}
        </li>)}
    </ul>;
}